module.exports = __webpack_public_path__ + "hinted-OpenSans-SemiboldItalic.8f448d115238d17fa39c.ttf";


//////////////////
// WEBPACK FOOTER
// C:/progetti java/ispra-infoaria/ispra-infoaria/ispra-infoaria-wui/infoaria-wui-client/src/assets/custom-styles/fonts/hinted-OpenSans-SemiboldItalic.ttf
// module id = ../../../../../src/assets/custom-styles/fonts/hinted-OpenSans-SemiboldItalic.ttf
// module chunks = 1